import { del, get } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToPaginatedJSON, paginateAPIOptions, } from "../util/amplify-utils";
function alertsFilterToQueryParams(filter) {
    const query = {};
    if (filter?.eventCategories !== undefined) {
        query["event_categories"] = filter.eventCategories.join(",");
    }
    return query;
}
export default class VelavuAPIAlerts {
    //This method returns all of an organization's alerts
    getAllAlerts(params, pagination) {
        return normalizePromiseError(operationToPaginatedJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/alerts",
            options: paginateAPIOptions(pagination, {
                queryParams: alertsFilterToQueryParams(params),
            }),
        })));
    }
    //This method deletes a single alert
    deleteAlert(alertID) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/alerts/${alertID}`,
        }).response);
    }
    //This method deletes all of an organization's alerts
    deleteAllAlerts(params) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/alerts`,
            options: {
                queryParams: alertsFilterToQueryParams(params),
            },
        }).response);
    }
}
//# sourceMappingURL=velavu-api-alerts.js.map